import React from 'react';
import styles from './StatsSection.module.scss';
import { useTranslation } from 'react-i18next';

type StatItem = {
  icon: string;
  title: string;
  value: string;
};

export default function StatsSection() {
  const { t } = useTranslation();
  const stats: StatItem[] = [
    {
      icon: '/images/auction-icon.png',
      title: t('marketplacesummary.auctionsLabel'),
      value: '0',
    },
    {
      icon: '/images/seller.png',
      title: t('marketplacesummary.sellersLabel'),
      value: 'O',
    },
    {
      icon: '/images/credit-card-buyer.png',
      title: t('marketplacesummary.buyersLabel'),
      value: '0',
    },
    {
      icon: '/images/carbon-cloud-arrow-down.png',
      title: t('marketplacesummary.offsetLabel'),
      value: '0',
    },
  ];

  return (
    <section className={styles['stats-section']}>
      <div className={styles['heading-container']}>
        <h2 className={styles['section-heading']}>{t('marketplacesummary.marketPlaceSummaryMainHeading')}</h2>
        <div className={styles['heading-divider']} />
      </div>
      <div className={styles['stats-container']}>
        {stats.map((stat, index) => (
          <div key={index} className={styles['stat-item']}>
            <div className={styles['stat-icon']}>
              <img src={stat.icon} alt={stat.title} className={styles['stat-icon-img']} />
            </div>
            <h3 className={styles['stat-value']}>{stat.value}</h3>
            <p className={styles['stat-title']}>{stat.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
